<h1 mat-dialog-title>Log out</h1>
<div mat-dialog-content>
  <p>Are you sure you would like to log out?</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true">Yes, log out</button>
  <button mat-button mat-dialog-close cdkFocusInitial>Cancel</button>
</div>
 